<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/permission/index' }">权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>权限修改</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="formData" label-width="100px">
          <el-form-item label="权限组名称">
            <el-col :span="12">
              <el-input size="small" v-model="formData.group_name" placeholder="请输入权限组名称"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="权限">
            <el-col :span="12">
              <el-tree
                ref="tree"
                :data="menuList"
                :check-on-click-node="true"
                show-checkbox
                @check-change="clickTreeNode"
                node-key="id"
                :default-checked-keys="formData.show_group_jurisd_id"
              ></el-tree>
              <!-- :default-expanded-keys="formData.group_jurisd_id" -->
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      id: "",
      formData: {
        group_name: "",
        group_jurisd_id: [],
        show_group_jurisd_id: []
      },
      parentCode:[],
      menuList: []
    };
  },

  methods: {
    clickTreeNode() {
      this.formData.group_jurisd_id = this.$refs.tree.getCheckedKeys();
      this.parentCode = this.$refs.tree.getHalfCheckedKeys();
    },
    save() {
      if (this.formData.group_name == "") {
        this.$util.msg("请输入权限组名称");
      } else if (this.formData.group_jurisd_id.length == 0) {
        this.$util.msg("请选择权限");
      } else {
        let _group_jurisd_id = Array.from(new Set(this.parentCode.concat(this.formData.group_jurisd_id)));
        this.$ajax({
          loading: true,
          type: "post",
          url: "/permission/update",
          data: {
            id: this.id,
            group_name: this.formData.group_name,
            group_jurisd_id: _group_jurisd_id.join(",")
          }
        }).then(data => {
          this.$util.msg("修改成功", "success");
          setTimeout(() => {
            this.$router.push({ path: "/permission/index" });
          }, 1200);
        });
      }
    },
    checked(id, data, newArr) {
      data.forEach(item => {
        if (item.id == id) {
          if (item.children.length == 0) {
            newArr.push(item.id);
          }
        } else {
          if (item.children.length != 0) {
            this.checked(id, item.children, newArr);
          }
        }
      });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.$ajax({
      url: "/permission/tree"
    })
      .then(data => {
        this.menuList = this.$util.menuList(data.data);
      })
      .then(data => {
        this.$ajax({
          loading: true,
          url: "/permission/one",
          data:{
            id: this.id
          }
        }).then(data => {
          this.formData.group_name = data.data.group_name;
          this.formData.group_jurisd_id = data.data.group_jurisd_id.split(",");

          let newArr = [];
          this.formData.group_jurisd_id.forEach(item => {
            this.checked(item, this.menuList, newArr);
          });
          this.formData.show_group_jurisd_id = newArr;
        });
      });
  }
};
</script>
<style>
</style>